module.exports = {
	"id": "RW",
	"name": "Rwanda",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": 0.002124,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.004248,
			"11": 0.012744,
			"12": null,
			"13": null,
			"14": null,
			"15": 0.006372,
			"16": 0.004248,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.002124,
			"22": 0.078588,
			"23": 0.012744,
			"24": null,
			"25": null,
			"26": 0.008496,
			"27": null,
			"28": 0.006372,
			"29": 0.006372,
			"30": null,
			"31": 0.008496,
			"32": 0.002124,
			"33": 0.02124,
			"34": 0.002124,
			"35": null,
			"36": 0.019116,
			"37": null,
			"38": 0.008496,
			"39": 0.004248,
			"40": 0.004248,
			"41": null,
			"42": 0.023364,
			"43": 0.248508,
			"44": 0.01062,
			"45": 0.04248,
			"46": 0.008496,
			"47": 0.057348,
			"48": 0.036108,
			"49": 0.237888,
			"50": 0.038232,
			"51": 0.248508,
			"52": 0.133812,
			"53": 7.334172,
			"54": 2.32578,
			"55": 0.055224,
			"56": 0.01062,
			"57": null
		},
		"firefox": {
			"2": 0.002124,
			"3": 0.0531,
			"4": 0.03186,
			"5": 0.025488,
			"6": 0.014868,
			"7": 0.006372,
			"8": 0.016992,
			"9": 0.014868,
			"10": 0.014868,
			"11": 0.02124,
			"12": 0.03186,
			"13": 0.012744,
			"14": 0.02124,
			"15": 0.012744,
			"16": 0.014868,
			"17": 0.012744,
			"18": 0.012744,
			"19": 0.016992,
			"20": 0.1593,
			"21": 0.029736,
			"22": 0.006372,
			"23": 0.012744,
			"24": 0.01062,
			"25": 0.008496,
			"26": 0.008496,
			"27": 0.004248,
			"28": 0.008496,
			"29": 0.019116,
			"30": 0.023364,
			"31": 0.036108,
			"32": 0.01062,
			"33": 0.019116,
			"34": 0.014868,
			"35": 0.025488,
			"36": 0.019116,
			"37": 0.016992,
			"38": 0.038232,
			"39": 0.012744,
			"40": 0.07434,
			"41": 0.027612,
			"42": 0.016992,
			"43": 0.203904,
			"44": 0.208152,
			"45": 0.076464,
			"46": 0.087084,
			"47": 0.581976,
			"48": 0.420552,
			"49": 3.587436,
			"50": 0.422676,
			"51": 0.004248,
			"52": null,
			"3.5": 0.004248,
			"3.6": 0.046728
		},
		"opera": {
			"9": null,
			"11": 0.002124,
			"12": null,
			"15": null,
			"16": 0.002124,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.012744,
			"30": null,
			"31": null,
			"32": 0.004248,
			"33": 0.004248,
			"34": 0.002124,
			"35": 0.036108,
			"36": 0.02124,
			"37": 0.184788,
			"38": 0.004248,
			"39": 0.025488,
			"40": 0.367452,
			"41": 0.038232,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": 0.006372,
			"11.6": 0.016992,
			"12.1": 0.044604
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": null,
			"7": 0.006372,
			"8": 0.065844,
			"9": 0.04248,
			"10": 0.22302,
			"3.1": null,
			"3.2": null,
			"5.1": 0.025488,
			"6.1": 0.004248,
			"7.1": 0.008496,
			"9.1": 0.16992
		},
		"ios_saf": {
			"8": 0,
			"10": 0.543785009159,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0146543767694,
			"8.1-8.4": 0.0270733401332,
			"9.0-9.2": 0.0129157218984,
			"9.3": 0.19704755204
		},
		"android": {
			"3": 0,
			"4": 0.0474391627907,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00592989534884,
			"4.1": 0.171119837209,
			"4.2-4.3": 0.427799593023,
			"4.4": 0.980974116279,
			"4.4.3-4.4.4": 0.989445395349
		},
		"ie": {
			"6": null,
			"7": 0.004248,
			"8": 0.142308,
			"9": 0.057348,
			"10": 0.099828,
			"11": 0.61596,
			"5.5": null
		},
		"op_mob": {
			"0": 4.5130316372,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.125361989922
		},
		"edge": {
			"12": 0.07434,
			"13": 0.189036,
			"14": 0.078588
		},
		"ie_mob": {
			"10": 0.0683326197183,
			"11": 0.278211380282
		},
		"bb": {
			"7": 0.057101,
			"10": null
		},
		"samsung": {
			"0": 0.74822
		},
		"and_uc": {
			"0": 2.63846
		},
		"op_mini": {
			"0": 60.8032903729
		},
		"and_chr": {
			"0": 6.139344
		},
		"and_ff": {
			"0": 0.007876
		}
	},
	"total": 98.988157
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/RW.json
 ** module id = 636
 ** module chunks = 0
 **/